// Expose Leaflet's `L` on window BEFORE the gesture-handling UMD plugin loads —
// that plugin references a bare global `L` at module-eval time. This file must
// contain ONLY this import so it fully evaluates before the plugin's import.
import L from "leaflet"

;(window as unknown as { L: typeof L }).L = L

export default L
